<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">beach_access</v-icon>
          <span class="headline ml-2 white--text">Timeoff policies</span>
          <v-spacer />
          <span>
            <v-btn @click="add" depressed class="action white--text rounded-sm"
              >add</v-btn
            >
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-col cols="12">
            <v-card
              v-for="item in leaveTypes"
              :key="item.id"
              class="my-1 py-4 action"
            >
              <v-card-title primary-title class="pa-0">
                <v-row>
                  <v-col cols="12" md="2" class="hidden-sm-and-down">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-icon x-large color="white">policy</v-icon>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="8" sm="10" class="white--text">
                    <div class="headline">{{ item.name }}</div>
                    <div>{{ item.description }}</div>
                    <div class="row body-2 hidden-sm-and-down mt-1">
                      <div class="col-md-4">
                        <div>Type: {{ item.type }}</div>
                        <div>Accrual: {{ item.accrual.enabled }}</div>
                        <div>Carryover: {{ item.carryover.enabled }}</div>
                      </div>
                      <div class="col-md-8">
                        <div>
                          Count all calendar days:
                          {{
                            item.count_holidays ? item.count_holidays : false
                          }}
                        </div>
                        <div>
                          Added On: {{ item.created ? item.created : "" }}
                        </div>
                        <div>Restrictions: {{ item.restrictions.enabled }}</div>
                      </div>
                    </div>
                  </v-col>
                  <v-col sm="2" class="mt-3 text-right pr-5">
                    <v-btn
                      @click="edit(item)"
                      depressed
                      class="theme-text rounded-sm"
                    >
                      Edit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col>
            <div v-if="hh" class="text-center mt-6">
              <v-btn
                fab
                small
                class="theme white--text"
                depressed
                @click="previous"
                :disabled="pagination.page <= 0"
              >
                <v-icon small>navigate_before</v-icon>
              </v-btn>
              <span class="mx-6">{{ pagination.page + 1 }}</span>
              <v-btn
                fab
                small
                depressed
                class="theme white--text"
                @click="next"
                :disabled="pagination.disableNext"
              >
                <v-icon small>navigate_next</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col offset-lg="1" lg="10">
      <v-row class="px-1">
        <v-col
          cols="12"
          sm="6"
          md="4"
          class="mt-2"
          v-for="item in adminLeavePolicies"
          :key="item.id"
        >
          <v-card height="470px">
            <v-responsive height="150px" class="theme">
              <v-row class="fill-height" align="center" justify="center">
                <v-icon style="font-size: 80px" color="white">policy</v-icon>
              </v-row>
            </v-responsive>
            <v-card-title primary-title>
              <div>
                <h4 class="headline mb-4">{{ item.name }}</h4>
                <div class="subheading grey--text text--darken-1 mt-3">
                  A policy customized for employees in {{ item.country }}. You
                  can add this policy by clicking the button below and customize
                  it further by using the edit view.
                </div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-btn
                depressed
                @click="addPolicy(item)"
                color="action white--text rounded-sm ml-0 mb-0"
                >Add Policy
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Company.LeaveTypes.List,
  data: () => ({
    breadcrumbs: Breadcrumbs.Leaves.List,
    tokenHeader: null,
    hh: TableHeaders.Leaves,
    pagination: { disableNext: true, page: 0 },
    search: { type: "", limit: 10, offset: 0 },
    timeoff: {},
  }),
  computed: {
    ...mapGetters(["userInfo", "leaveTypes", "adminLeavePolicies"]),
  },
  methods: {
    edit(item) {
      if (this.userInfo.role !== Constants.Roles.HR) {
        return false;
      }
      if (!item || !item.id) {
        return false;
      }

      this.$router.push({
        name: Component.Protected.Company.LeaveTypes.Edit,
        params: { id: item.id },
      });
    },
    addPolicy(item) {
      if (!item) return false;
      // do not add again if the policy is added
      let exists = false;
      this.leaveTypes.forEach((e) => {
        if (e.name === item.name) {
          exists = true;
        }
      });

      if (exists) {
        this.snackbarMessage = "Policy already exists";
        this.snackbar = true;
        return false;
      }

      let yolo = { ...item };
      const co = {
        enabled: false,
        data: {
          annual_reset: false,
          annual_reset_date: Constants.LeaveTypes.Messages.Policy,
          unlimited_carryover: false,
          unlimited_carryover_date: Constants.LeaveTypes.Messages.Policy,
          balance_limit_required: false,
          balance_limit_days: 0,
          cap_required: false,
          cap_days: 0,
          cap_date: Constants.LeaveTypes.Messages.Policy,
          cap_with_deadline_required: false,
          cap_with_deadline_days_count: 0,
          cap_with_deadline_days_allowed: 0,
          cap_with_deadline_date: Constants.LeaveTypes.Messages.Policy,
        },
      };
      const pr = {
        enabled: false,
        data: { allowed: "No", waiting_period: "No", waiting_duration: 0 },
      };
      const res = {
        enabled: false,
        data: { cap_duration: "", cap_request: 0, cap_days: 0 },
      };
      const acc = {
        enabled: false,
        data: { frequency: "Annual", timing: "Start" },
      };
      let payload = {
        ...yolo,
        days: yolo.days ? parseInt(yolo.days) : 0,
        count_holidays:
          yolo.count_holidays === null ? false : yolo.count_holidays,
        approval: "Single",
        carryover: yolo.carryover.enabled === null ? co : yolo.carryover,
        prorate: yolo.prorate.enabled === null ? pr : yolo.prorate,
        restrictions:
          yolo.restrictions.enabled === null ? res : yolo.restrictions,
        accrual: acc,
      };

      payload.prorate.data.waiting_duration = parseInt(
        payload.prorate.data.waiting_duration
      );
      payload.restrictions.data.cap_request = parseInt(
        payload.restrictions.data.cap_request
      );
      payload.restrictions.data.cap_days = parseInt(
        payload.restrictions.data.cap_days
      );
      payload.carryover.data.balance_limit_days = parseInt(
        payload.carryover.data.balance_limit_days
      );
      payload.carryover.data.cap_days = parseInt(
        payload.carryover.data.cap_days
      );
      payload.carryover.data.cap_with_deadline_days_count = parseInt(
        payload.carryover.data.cap_with_deadline_days_count
      );
      payload.carryover.data.cap_with_deadline_days_allowed = parseInt(
        payload.carryover.data.cap_with_deadline_days_allowed
      );
      this.$store
        .dispatch(Actions.LeaveTypes.Add, payload)
        .then(() => this.getTimeOffPolicies())
        .catch((e) => {
          console.error(Constants.LeaveTypes.Messages.Error.Add, e);
          this.snackbarMessage = Constants.LeaveTypes.Messages.Error.Add;
          this.snackbar = true;
        });
    },
    assign(item) {
      alert("todo : Add assign timeoff to employees. policy id [" + item + "]");
    },
    add() {
      this.$router.push({ name: Component.Protected.Company.LeaveTypes.Add });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        return false;
      }
      this.adminPolicies();
      this.getTimeOffPolicies();
    },
    adminPolicies() {
      this.$store.dispatch(Actions.LeaveTypes.Admin).catch((e) => {
        console.error(Constants.LeaveTypes.Messages.Error.Admin, e);
        this.snackbar = true;
        this.snackbarMessage = Constants.LeaveTypes.Messages.Error.Admin;
      });
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.leaveTypes.length < this.search.limit) {
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getTimeOffPolicies();
        // this.pagination.disableNext = false;
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.search.offset = this.search.limit * this.pagination.page;
        this.getTimeOffPolicies();
        // this.pagination.disableNext = false;
      }
    },
    getTimeOffPolicies() {
      this.$store
        .dispatch(Actions.LeaveTypes.Find, this.search)
        .then(() => {
          let len = this.leaveTypes.length;
          if ((len < this.search.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.search.limit) {
            this.pagination.disableNext = false;
          }
          this.$forceUpdate();
        })
        .catch((e) => {
          this.snackbarMessage = Constants.LeaveTypes.Messages.Error.Find;
          this.snackbar = true;
          console.error(Constants.LeaveTypes.Messages.Error.Find, e);
        });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
